<template>
    <div>
        <div class="pro-fillin" v-if="open">
            <svg-icon class="only-view-svg" name="close" @click="open=false;$emit('close',false)" />
            <div class="logo">
                <img :src="$store.state.user_data.merchant_account.store_front_logo" alt="logo">
            </div>

            <div class="fill-other-box">
                <div class="title-text">{{ show_text.title }}</div>
                <div class="desc" v-html="show_text.desc"></div>
                <Button :style="'border'" size="32" :border_r="8" @click="handleBtn" :flex="true" class="edit-btn"
                    v-if="show_text.btn">{{ show_text.btn }}</Button>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import ProgramForm from './ProgramForm.vue';
import FormFormRight from './FormFormRight.vue';
import Loading from '@/components/ui/Loading.vue';
import moment from 'moment';
import Modal from '@/components/ui/Modal.vue';
import { FormList, FormSetting, OtherFormSetting, getIndex, getFormApiData, HandlefillinData } from '@/utils/ProgramsData.js';

export default {
    name: 'Form-Setting',

    data() {
        return {
            open:false,
            show_text: {
                title: ``,
                desc: ``,
                btn: ``,
            },
        }
    },

    computed: {
    },

    components: {
        ProgramForm,
        FormFormRight,
        Loading,
        Modal,
        Button,
    },

    watch: {

    },

    methods: {
        handleBtn() {
            window.open(this.$store.state.user_data.merchant_account.main_domain, "_blank");
        },
    },


    async mounted() {

        this.EventBus.off('open-form-fillin');
        this.EventBus.on('open-form-fillin', async (item) => {
            this.open=true;

            item.data.group_setting.forEach((e,k)=> {

                const repVal=(field)=>{
                    let val=e.client_view.val?e.client_view.val:e.client_view.plac;
        
                    if (val.includes("{{ApplicationTitle}}")) {
                        val = val.replace("{{ApplicationTitle}}", item.title);
                    }

                    if (val.includes("{{ApplicantID}}")) {
                        val= val.replace("{{ApplicantID}}", 1234);
                    }

                    if (val.includes("{{Brand}}")) {
                        val= val.replace("{{Brand}}", this.$store.state.user_data.merchant_account.merchant_display_name);
                    }

                    if (val.includes("{{StorefrontActivationLink}}")) {
                        val= val.replace("{{StorefrontActivationLink}}", `https://www.qa.motom.me/rs/6ibFhi`);
                    }

                    if (val.includes("{{ApplicationSubmitDate}}")) {
                        const formattedDate = moment(new Date()).format('MMM D, YYYY');
                        const formattedTime = moment(new Date()).format('h:mma (UTC Z)');
                        val= val.replace("{{ApplicationSubmitDate}}", `${formattedDate} ${formattedTime}`);
                    }

                    return val;
                }
                if(k===0){
                    this.show_text.title=repVal();
                }

                if(k===1){
                    this.show_text.desc=`${repVal()}<br/>`;
                }

                if(k===2){
                    this.show_text.desc += `${repVal()}`;
                }
            });

            this.show_text.btn= `Visit ${this.$store.state.user_data.merchant_account.merchant_display_name}`;
            this.show_text.url= this.$store.state.user_data.merchant_account.main_domain;
             
        });
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.pro-fillin{
    position:fixed;
    width:100vw;
    height:100vh;
    top:0;
    right:0;
    background-color: var(--light-neutral);
    z-index: 9991;

    .only-view-svg{
        width: 24px !important;
        height: 24px !important;
        cursor: pointer;
        position: absolute;
        top: 12px;
        right: 24px;
    }

    .logo {
        width: 220px;
        height: 100px;
        margin: 28px auto;
        @include flexCenter();
        overflow: hidden;

        img {
            width: 100%;
            height: 100px;
            object-fit: contain;
        }
    }

    .fill-other-box {
        @include flexCenter();
        justify-content: center;
        flex-wrap: wrap;
        align-content: center;
        height: 630px;
        background-color: var(--white);
        max-width: 980px;
        width: 90%;
        margin: auto;
        margin-bottom: 32px;
        padding: 24px;

        .title-text {
            font: var(--font-demi-30);
            color: var(--black-100);
            width: 100%;
            text-align: center;
        }

        .desc {
            font-size: 16px;
            color: var(--black-90);
            margin-top: 8px;
            width: 100%;
            text-align: center;
        }

        .ui-button {
            margin-top: 24px;
            padding: 0px 101px !important;

            @media screen and (max-width: 768px) {
                padding: 0px 24px !important;
            }
        }
    }
}
</style>